import { Component, OnInit, Input } from '@angular/core';
import { PartnerService } from '../../../../../services/partner.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TechnicianService } from '../../../../../services/technician.service';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { ProductsService } from '../../../../../services/products.service';
import { CyclistService } from '../../../../../services/cyclist.service';
import { AppConfig } from '../../../../../app.config';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VideoPlayerComponent } from '../../../../modals/video-player/video-player.component';
import { TechnicianWorkingHoursComponent } from 'src/app/components/modals/add-edit-user/technician-working-hours/technician-working-hours.component';

@Component({
  selector: 'app-configuration-overview',
  templateUrl: './configuration-overview.component.html',
  styleUrls: ['./configuration-overview.component.scss'],
})
export class ConfigurationOverviewComponent implements OnInit {
  @Input() linkedCyclists;
  public partner: any = this.helpersService.getPartnerData();
  public partnerID: any = this.helpersService.getPartnerId();

  public checklistConfig: any = [];
  public activeChecklistConfig = 0;
  public checklistConfigConfigured = -1;
  public serviceTypes: any = [];
  public activeServiceTypes = 0;
  public serviceTypesConfigured = -1;
  public messageTemplates: any = [];
  public activeMessageTemplates = 0;
  public messageTemplatesConfigured = -1;
  public technicians: any = [];
  public activeTechnicians = 0;
  public techniciansConfigured = -1;
  public cyclists: any = [];
  public users: any = [];
  public cyclistsConfigured = -1;
  public jobCardConfigured = -1;
  public posConfigured = -1;
  public posProducts = -1;
  public busyServiceTypes: boolean = false;
  public techniciansBusy: boolean = false;
  public busyMessages: boolean = false;
  public busyCyclists: boolean = false;
  public busyPosProducts: boolean = false;

  public overviewActionTypes = {
    USERS: 1,
    SERVICE_TYPES: 2,
    MESSAGE_TEMPLATES: 3,
    POS_CONFIG: 4,
    CUSTOMERS: 5,
  };

  constructor(
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private technicianService: TechnicianService,
    private posIntegrationService: PosIntegrationService,
    private cyclistService: CyclistService,
    private productsService: ProductsService,
    public router: Router,
    public modalService: NgbModal,
    private appConfig: AppConfig,
  ) {}

  ngOnInit() {
    this.getTechnicians();
    this.getPOSConfiguration();
    this.getChecklistConfig();
    this.getServiceTypes();
    this.getMessageTemplates();
    this.getProducts();
  }

  getProducts() {
    this.busyPosProducts = true;
    // this.productsService.getAllProducts(this.helpersService.getPartnerId()).subscribe(products => {
    //   this.helpersService.saveProductData(products);
    //   this.posProducts = this.helpersService.getProductData().length;
    //   this.busyPosProducts = false;
    // });
    var products = this.helpersService.getProductData();
    if (products && products.length > 0) {
      this.posProducts = this.helpersService.getProductData().length;
    } else {
      setTimeout(() => {
        this.getProducts();
      }, 5000);
    }
  }

  getChecklistConfig() {
    this.partnerService
      .getChecklistConfigAll(this.partnerID)
      .subscribe((checklist) => {
        this.checklistConfig = checklist;
        this.checklistConfigConfigured =
          checklist.filter((x) => {
            return x.IsActive === true;
          }).length > 0
            ? 1
            : 0;
        this.activeChecklistConfig = checklist.filter((x) => {
          return x.IsActive === true;
        }).length;
      });
  }

  getServiceTypes() {
    this.busyServiceTypes = true;
    this.partnerService
      .getPartnerServiceTypesFull(this.partnerID)
      .subscribe((serviceTypes) => {
        this.serviceTypes = serviceTypes;
        this.serviceTypesConfigured =
          serviceTypes.filter((x) => {
            return x.IsActive === true;
          }).length > 0
            ? 1
            : 0;
        this.activeServiceTypes = serviceTypes.filter((x) => {
          return x.IsActive === true;
        }).length;
        this.busyServiceTypes = false;
      });
  }

  getMessageTemplates() {
    this.busyMessages = true;
    this.messageTemplates = [];
    this.partnerService
      .getMessageTemplates(this.partnerID)
      .subscribe((messageTemplates) => {
        this.messageTemplatesConfigured =
          messageTemplates.filter((x) => {
            return x.IsActive === true;
          }).length > 0
            ? 1
            : 0;
        this.activeMessageTemplates = messageTemplates.filter((x) => {
          return x.IsActive === true;
        }).length;

        this.busyMessages = false;
      });
  }

  async getTechnicians() {
    this.techniciansBusy = true;
    this.partnerService
      .getPartnerTechnicians(this.partnerID)
      .subscribe((technicians) => {
        this.activeTechnicians = technicians.filter((x) => {
          return x.IsActive === true;
        }).length;
        if (this.technicians.length === 0) {
          this.techniciansConfigured = 0;
          this.techniciansBusy = false;
        }
      });
  }

  getPOSConfiguration() {
    if (this.partner.POSSystemID > 0) {
      this.posIntegrationService
        .checkPOSIntegration(this.partnerID, this.partner.POSSystemID)
        .subscribe(
          (pos) => {
            this.posConfigured = 1;
          },
          (err) => {
            this.posConfigured = 0;
          },
        );
    } else {
      this.posConfigured = 0;
    }
  }

  tutorialAction(event) {
    var tutorial = this.appConfig
      .getTutorialVideos()
      .filter((x) => {
        return x.type === event.type;
      })
      .pop();
    if (tutorial) {
      const modalRef = this.modalService.open(VideoPlayerComponent, {
        size: 'lg',
        backdrop: 'static',
      });
      modalRef.componentInstance.tutorial = tutorial;
      modalRef.result.then(
        (result) => {},
        (onrejected) => {},
      );
    }
  }

  overviewAction(event) {
    if (event.type === this.overviewActionTypes.SERVICE_TYPES) {
      this.goToServiceTypes();
    } else if (event.type === this.overviewActionTypes.USERS) {
      this.goToUsers();
    } else if (event.type === this.overviewActionTypes.MESSAGE_TEMPLATES) {
      this.goToMessageTemplates();
    } else if (event.type === this.overviewActionTypes.CUSTOMERS) {
      this.goToCyclists();
    } else if (event.type === this.overviewActionTypes.POS_CONFIG) {
      this.goToShopProfile();
    }
  }

  goToMessageTemplates() {
    this.router.navigateByUrl('/store/message-templates');
  }

  goToServiceTypes() {
    this.router.navigateByUrl('/store/service-types');
  }

  goToUsers() {
    this.router.navigateByUrl('/store/users');
  }

  goToCyclists() {
    this.router.navigateByUrl('/store/cyclists');
  }

  goToShopProfile() {
    this.router.navigateByUrl('/store/shop-profile');
  }
}
